import { jsx as _jsx } from "react/jsx-runtime";
import { Container as AEMContainer, MapTo } from "@adobe/aem-react-editable-components";
import classNames from "classnames/bind";
import { withEditConfig } from "../../app-related/withAemAuthoring";
import styles from "./Container.module.scss";
export { AEMContainer };
const classNamesBind = classNames.bind(styles);
const Container = ({ fullWidth = false, smallGap, type = "row", marginBottom = "none", marginTop = "none", ...args }) => {
    const classes = classNamesBind({
        container: type === "column",
        rowContainer: type === "row",
        marginBottomSmall: marginBottom === "small",
        marginTopSmall: marginTop === "small",
        marginBottomBig: marginBottom === "big",
        marginTopBig: marginTop === "big",
        fullWidth: fullWidth,
        smallGap: smallGap,
    });
    return _jsx(AEMContainer, { ...args, className: classes });
};
export default MapTo("loyalty/components/container")(withEditConfig(Container, {
    isEmpty: () => false,
}));
